import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RateLimitService, RateLimitState } from '../../services/rate-limit.service';

@Component({
  selector: 'app-rate-limit-toast',
  templateUrl: './rate-limit-toast.component.html',
  styleUrls: ['./rate-limit-toast.component.scss']
})
export class RateLimitToastComponent implements OnInit, OnDestroy {
  isVisible = false;
  timeRemaining = 0;
  isHome = false;
  progressPercentage = 100;
  private initialTime = 0;
  private subscription: Subscription;

  constructor(
    private rateLimitService: RateLimitService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // console.log('🎯 [RateLimitToast] Componente inicializado');

    // Suscribirse a los cambios de estado del rate limiting
    this.subscription = this.rateLimitService.rateLimitState$.subscribe(
      (state: RateLimitState) => {
        //console.log('🎯 [RateLimitToast] Estado recibido:', state);
        //console.log('🎯 [RateLimitToast] isVisible actual:', this.isVisible);

        if (state.isActive && state.timeRemaining > 0) {
          // Guardar tiempo inicial si es la primera vez
          if (!this.isVisible || state.timeRemaining > this.timeRemaining) {
            this.initialTime = state.timeRemaining;
            //console.log('🎯 [RateLimitToast] Tiempo inicial guardado:', this.initialTime);
          }

          this.isVisible = true;
          this.timeRemaining = state.timeRemaining;
          this.isHome = state.isHome;

          // Calcular porcentaje de progreso
          this.progressPercentage = (this.timeRemaining / this.initialTime) * 100;

          // console.log('🎯 [RateLimitToast] Toast activado:', {
          //   isVisible: this.isVisible,
          //   timeRemaining: this.timeRemaining,
          //   progressPercentage: this.progressPercentage,
          //   initialTime: this.initialTime
          // });
        } else if (state.isActive === false && state.timeRemaining === 0 && this.isVisible) {
          // Tiempo agotado, ejecutar acción
          //console.log('🎯 [RateLimitToast] Tiempo agotado, ejecutando acción');
          this.executeAction(state.isHome);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  /**
   * Ejecuta la acción cuando se agota el tiempo
   */
  private executeAction(isHome: boolean): void {
    // console.log('⏱️ [RateLimitToast] Tiempo agotado. El servicio manejará la recarga.');

    // Solo ocultar el toast
    // La recarga la maneja el RateLimitService automáticamente
    this.isVisible = false;
  }

  /**
   * Convierte segundos a formato legible (minutos y segundos)
   */
  private formatTime(seconds: number): string {
    if (seconds < 60) {
      // Solo segundos
      return `${seconds} segundo${seconds !== 1 ? 's' : ''}`;
    } else {
      // Minutos y segundos
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;

      if (remainingSeconds === 0) {
        // Solo minutos exactos
        return `${minutes} minuto${minutes !== 1 ? 's' : ''}`;
      } else {
        // Minutos y segundos
        return `${minutes} minuto${minutes !== 1 ? 's' : ''} y ${remainingSeconds} segundo${remainingSeconds !== 1 ? 's' : ''}`;
      }
    }
  }

  /**
   * Obtiene el mensaje a mostrar
   */
  getMessage(): string {
    const timeFormatted = this.formatTime(this.timeRemaining);
    return `Has excedido el límite de peticiones. La página se recargará automáticamente en ${timeFormatted}...`;
  }
}
